import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/driving-info/DrivingInfoTrip/.eu';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoTrip/.kr';

export interface DrivingInfoTripProps {
  vin: string;
  selectedDate: Date;
}

export default function DrivingInfoTrip({vin, selectedDate}: DrivingInfoTripProps) {
  return (
    <>
      <Environment.Eu>
        <Eu
          vin={vin}
          selectedDate={selectedDate}
        />
      </Environment.Eu>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
        />
      </Environment.Kr>
    </>
  );
}
